<div class="flex flex-col h-full">
  <app-sidebar-header [sidebar]="sidebar"></app-sidebar-header>
  <div class="grow">
    <app-sidebar-services [compactView]="compactView"/>
  </div>
  <app-sidebar-options [compactView]="compactView"/>
  <div [class.invisible]="compactView">
    <app-sidebar-back-button />
  </div>
</div>
